// Ref: _.unescape from https://github.com/jashkenas/underscore/blob/master/underscore.js
// List of HTML entities for escaping.
export const unescapeMap = {
  '&#39;': "'",
  '&#96;': '`',
  '&amp;': '&',
  '&gt;': '>',
  '&lt;': '<',
  '&quot;': '"'
};

// Functions for unescaping strings to/from HTML interpolation.
const createEscaper = map => {
  const escaper = match => map[match];
  // Regexes for identifying a key that needs to be escaped.
  const source = `(?:${Object.keys(unescapeMap).join('|')})`;
  const testRegexp = RegExp(source);
  const replaceRegexp = RegExp(source, 'g');
  return function(string) {
    string = String(string);
    return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
  };
};
const unescape = createEscaper(unescapeMap);
export default unescape;
